module.exports = __webpack_public_path__ + "static/media/slider03_sc.75c619d3.png";